module.exports = __webpack_public_path__ + "static/img/airTickets.8795904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/airTickets.png
// module id = fakK
// module chunks = 1